import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getSeats, deleteSeat, changeSeatStatus } from "../api/seatApi";
import { confirmDialog } from "../utils/alert";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";

export default function SeatsList() {
  const [seats, setSeats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const loadSeats = async () => {
    setLoading(true);
    try {
      const res = await getSeats({ page, per_page: perPage });
      setSeats(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSeats();
  }, [page, perPage]);

  const handleDelete = async (id) => {
    const confirmed = await confirmDialog({ text: "Delete this seat?" });
    if (!confirmed) return;
    await deleteSeat(id);
    loadSeats();
  };

  const handleToggleActive = async (seat) => {
    await changeSeatStatus(seat.id, !seat.is_active);
    loadSeats();
  };

  return (
    <AdminLayout title="Seats">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title mb-0">Seat List</h5>
            <button
              className="btn skedq-accent-btn"
              onClick={() => navigate("/seats/new")}
            >
              Add New Seat
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Name</th>
                  <th>Hierarchy</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && seats.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No seats found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  seats.map((s, index) => (
                    <tr key={s.id}>
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td>{s.seat_name}</td>
                      <td>{s.hierarchy_level}</td>
                      <td>
                        <span
                          className={
                            "badge " +
                            (s.is_active ? "bg-success" : "bg-secondary")
                          }
                        >
                          {s.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => navigate(`/seats/edit/${s.id}`)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => handleToggleActive(s)}
                          >
                            {s.is_active ? "Deactivate" : "Activate"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(s.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
